module.exports = __webpack_public_path__ + "img/kyz1.c1340181.png";